import { sel } from '../utils'

export default function alert() {
  // return
  const alert$ = sel('.alert')
  const hero$ = sel('.hero')
  if (!alert$ || !hero$) return
  let reduceHeight = alert$.offsetHeight
  const stickyNavbar$ = sel('.navbar-sticky')
  if (stickyNavbar$) {
    const navbarHeight = stickyNavbar$.offsetHeight
    reduceHeight += navbarHeight
  }
  // console.log(alert$, hero$, reduceHeight)
  // important
  // hero$.style.setProperty('height', `calc(100vh - ${reduceHeight}px)`, 'important')
  // hero$.style.minHeight = `calc(100vh - ${reduceHeight}px)`
  // hero$.style.height = `calc(100vh - ${reduceHeight}px)`
}
